function closest(num, arr) {
  var curr = arr[0]
  var diff = Math.abs(num - curr)
  for (var val = 0; val < arr.length; val++) {
    var newdiff = Math.abs(num - arr[val])
    if (newdiff < diff) {
      diff = newdiff
      curr = arr[val]
      //check if there is next max
      if (arr[val + 1]) {
        //if there is check the middle point
        const middle = (arr[val + 1] - curr) / 2
        //if diff is in the middle or more set to next val
        if (diff >= middle) {
          curr = arr[val + 1]
        }
      }
    }
  }
  return curr
}

export default function(list, value, base) {
  function convertWeightToG(val, unit) {
    if (base === "weight" && unit === "kg") {
      return parseFloat(val) * 1000
    }
    return val
  }
  const count = list.reduce(function(a, c) {
    a.push(c.min_value ? convertWeightToG(c.min_value, c.weight_unit) : 0)
    a.push(
      c.max_value
        ? convertWeightToG(c.max_value, c.weight_unit)
        : Number.MAX_VALUE
    )
    return a
  }, [])
  const rate =
    (list &&
      list.find(function(l) {
        return (
          parseFloat(value) >=
            parseFloat(
              l.min_value ? convertWeightToG(l.min_value, l.weight_unit) : 0
            ) &&
          parseFloat(value) <=
            parseFloat(
              l.max_value
                ? convertWeightToG(l.max_value, l.weight_unit)
                : Number.MAX_VALUE
            )
        )
      })) ||
    null
  let shipping =
    rate ||
    list.find(function(l) {
      return (
        convertWeightToG(l.max_value, l.weight_unit) ===
          closest(value, count) ||
        convertWeightToG(l.min_value, l.weight_unit) === closest(value, count)
      )
    })
  return shipping
}
